// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilBlack":"#2c2e2f","easilGrayXDark":"#57595D","easilGrayDark":"#7A7D81","background":"style_background__3jZBS","card":"style_card__K2u5S"};